import angular from 'angular';

class containerDeleteModalCtrl {
    /* @ngInject */
    constructor(
        ContainerService,
        logger
    ) {
        this.ContainerService = ContainerService;
        this.logger = logger;
    }

    $onInit() {
        this.containerId = angular.copy(this.resolve.containerId);
    }

    cancel() {
        this.modalInstance.dismiss();
    }

    //Delete Container If Ready.
    confirmSubmit() {

        //check If container has pils or has invited seller.
        var containersIds = [];
        containersIds.push(this.containerId);
        this.ContainerService.checkContainersDeletion(containersIds).$promise.then(
            data => {
                // Container No pils And No invited seller.
                if(data[0] === containersIds[0]) {
                    this.ContainerService.deleteContainers(containersIds).$promise.then(
                        () => {
                            this.modalInstance.close();

                        },
                        () => {
                            this.logger.error('error.delete');
                            this.cancel();
                        }
                    );
                } else {
                    this.logger.error('error.deleteContainer');
                    this.cancel();
                }
            },
            () => {
                this.modalInstance.close();
                this.logger.error('error.search');
            }
        );
    }
}

angular.module('principal').component('containerDeleteModal', {
    templateUrl: require('./container-delete-modal.html'),
    controller: containerDeleteModalCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
